import { format as dateFormat, isValid as isValidDate } from 'date-fns';

export const capitalize = (str) => {
  if (!str || !str.length) { return str; }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatTimestamp = (str) => {
  const d = new Date(+str);
  const curDate = d.getDate();
  const curMonth = d.getMonth() + 1;
  const curYear = d.getFullYear();
  return `${curMonth}/${curDate}/${curYear}`;
};

export const sheetColumn = (str) => {
  const num = parseInt(str, 10);

  // ezpz
  if (num < 26) {
    return String.fromCharCode(65 + num);
  }

  // A little more complicated
  const first = Math.floor(num / 26);
  const second = num % 26;

  return String.fromCharCode(65 + first - 1) + String.fromCharCode(65 + second);
};

const ignoredWords = [
  'win',
];
const allCapsWords = [
  'babip',
  'fpct',
  'whip',
];

export const snakeToCapitalized = (str) => {
  // omit __typename as a field (on sportradar data)
  if (str === '__typename') {
    return '';
  }

  if (str && str.length) {
    const formattedWord = str
      .split('_')
      .map((word, i, wordsArr) => {
        const isLastWord = i === (wordsArr.length - 1);
        const isShortWord = word.length <= 3;
        const isNotIgnoredWord = !ignoredWords.includes(word);
        const isAllCapsWord = allCapsWords.includes(word);

        if (isLastWord && isNotIgnoredWord && (isShortWord || isAllCapsWord)) {
          return word.toUpperCase();
        }

        return word[0].toUpperCase() + word.substring(1);
      })
      .join(' ')
      .trim(); // Pre-formatting capitalization and snake case handling
    const pascalCaseMatches = formattedWord.match(/($[a-z])|[A-Z][^A-Z]+/g);
    const isPascalCase = pascalCaseMatches.length > 1 && !formattedWord.includes(' ');
    return (isPascalCase) ? pascalCaseMatches.join(' ') : formattedWord;
  }

  return '';
};

export const monthDay = (date) => dateFormat(new Date(date), 'MM/dd');

export const eventDisplayName = (game) => {
  const scheduledFor = game?.scheduledFor;
  const participantType = game?.participantType;
  const parsedScheduledFor = scheduledFor ? new Date(scheduledFor) : null;
  const eventDate = parsedScheduledFor && isValidDate(parsedScheduledFor)
    ? dateFormat(parsedScheduledFor, 'MM/dd/yyyy')
    : '';

  const awayTeamAlias = game?.awayTeam?.teamAlias;
  const homeTeamAlias = game?.homeTeam?.teamAlias;
  if (participantType === 'team_v_team' || (awayTeamAlias && homeTeamAlias)) {
    return eventDate
      ? `${eventDate}: ${awayTeamAlias || 'TBD'} @ ${homeTeamAlias || 'TBD'}`
      : `${awayTeamAlias || 'TBD'} @ ${homeTeamAlias || 'TBD'}`;
  }

  const eventTitle = game?.eventTitle || 'TBD';
  return eventDate ? `${eventDate} @ ${eventTitle}` : `@ ${eventTitle}`;
};

export const playerDisplayName = (player) => {
  let firstName = player?.firstName || '';
  let lastName = player?.lastName || '';
  if (!lastName.length && firstName.length) {
    lastName = firstName;
    firstName = '';
  }
  if (!lastName.length) {
    lastName = 'Unknown Player';
  }

  return (!firstName.length)
    ? lastName
    : `${lastName}, ${firstName}`;
};

export default {
  capitalize,
  eventDisplayName,
  formatTimestamp,
  monthDay,
  playerDisplayName,
  sheetColumn,
  snakeToCapitalized,
};
